import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Notfound from '../components/common/Images/404.webp';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC<any> = () => {
  const { t } = useTranslation('translation');
  const navigate = useNavigate();

  return (
    <div className='h-screen w-screen items-center flex flex-col justify-center'>
        <Grid><img src={Notfound} alt="" /></Grid>
        <Grid className='text-[4rem] text-[#807d7d]'>404</Grid>
        <Grid className='text-[1.5rem] text-[#9c9898]'>{t('pageNotFound')}</Grid>
        <Grid className='text-[1rem] text-[#807e7e]'>{t('pageNotFoundDescription')}</Grid>
        <Grid className='mt-4'> 
          <Grid className='underline underline-offset-1 text-[#807d7d] cursor-pointer' onClick={() => navigate('/')}>{t('goToLoginPage')}</Grid>
        </Grid>
    </div>
  )
}

export default NotFound